import { render, staticRenderFns } from "./sightingsview.vue?vue&type=template&id=5db1a019"
import script from "./sightingsview.vue?vue&type=script&lang=js"
export * from "./sightingsview.vue?vue&type=script&lang=js"
import style0 from "./sightingsview.vue?vue&type=style&index=0&id=5db1a019&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports